module.exports = __webpack_public_path__ + "img/Group 27993@2x.e520b3f3.png";